export enum MobilePageViewCustomDimensionId {
  ScreenReaderEnabled = 1,
  PrefersReducedMotion = 2,
  DynamicFontSize = 3,
  ColorScheme = 4,
  DeviceOrientation = 5,
}

export enum WebPageViewCustomDimensionId {
  Language = 1,
}
